/* Scroll-driven frame sequence (snippets/lb-scrollstack.liquid). Pre-rendered frames on a canvas, scrubbed by scroll. */
(function () {
  var root = document.querySelector('[data-lb-stack]');
  if (!root) return;
  var base = root.getAttribute('data-base'), n = +root.getAttribute('data-count'), ext = root.getAttribute('data-ext') || 'webp';
  var canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d');
  var steps = [].slice.call(root.querySelectorAll('.lb-stack__step')), dots = [].slice.call(root.querySelectorAll('.lb-stack__dots i'));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HOLD_IN = 0.08, HOLD_OUT = 0.14;           // share of the scroll spent before it starts and after it ends
  var imgs = [], want = reduce ? n - 1 : 0, shown = -1, started = false;

  function url(i) { return base + ('000' + i).slice(-3) + '.' + ext; }
  function load(i) {
    if (imgs[i]) return;
    var im = new Image(); im.decoding = 'async'; im.onload = function () { if (i === want || shown < 0) draw(want); };
    im.src = url(i); imgs[i] = im;
  }
  function ready(i) { return imgs[i] && imgs[i].complete && imgs[i].naturalWidth; }
  function draw(i) {
    var j = i; while (j >= 0 && !ready(j)) j--;       // nearest loaded frame at or before the wanted one
    if (j < 0) { j = i; while (j < n && !ready(j)) j++; if (j >= n) return; }
    if (j === shown) return;
    var im = imgs[j];
    if (canvas.width !== im.naturalWidth) { canvas.width = im.naturalWidth; canvas.height = im.naturalHeight; }
    ctx.clearRect(0, 0, canvas.width, canvas.height); ctx.drawImage(im, 0, 0); shown = j;
  }
  function loadAll() {
    if (started) return; started = true;
    load(0); load(n - 1);
    var order = [], i; for (i = 1; i < n - 1; i += 4) order.push(i);       // coarse pass first, then fill in
    for (var off = 1; off < 4; off++) for (i = off; i < n - 1; i += 4) if (order.indexOf(i) < 0) order.push(i);
    var k = 0; (function pump() { for (var c = 0; c < 6 && k < order.length; c++) load(order[k++]); if (k < order.length) setTimeout(pump, 60); })();
  }
  function setStep(s) {
    steps.forEach(function (el, i) { el.classList.toggle('is-on', reduce || i === s); });
    dots.forEach(function (el, i) { el.classList.toggle('is-on', i <= s); });
  }
  function update() {
    if (reduce) return;
    var r = root.getBoundingClientRect(), pin = root.querySelector('.lb-stack__pin');
    var top = parseFloat(getComputedStyle(root).getPropertyValue('--lb-stack-top')) || 0;
    var p = Math.min(1, Math.max(0, (top - r.top) / Math.max(1, r.height - pin.offsetHeight)));
    var m = Math.min(1, Math.max(0, (p - HOLD_IN) / (1 - HOLD_IN - HOLD_OUT)));
    want = Math.round(m * (n - 1));
    draw(want);
    setStep(Math.min(steps.length - 1, Math.floor(m * steps.length * 0.999)));
  }
  var tick = false;
  function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; update(); }); }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { if (es[0].isIntersecting) { loadAll(); } }, { rootMargin: '1500px 0px' }).observe(root);
  } else { loadAll(); }
  load(0);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setStep(reduce ? n : 0); update();
})();
